// Import required libraries and components
import React, { useEffect, useState } from "react"; 
import AllDropDownsAHSF from "../AllDropDownsAHSF"; // Dropdown component
import TextAreaAHSF from "../TextAreaAHSF"; // TextArea component
import { useDispatch, useSelector } from "react-redux"; // Redux hooks
import {
  GetRecommendationEvaluation,
  GetRecommendationsDropDown,
  UpdateRecommendationEvaluation,
} from "../../Redux/Reducers/RecommendationEvaluationManager"; // Redux actions
import SharedDiv from "../SharedDiv/SharedDiv"; // Shared container component
import { SetDataUser } from "../../Redux/Reducers/UserInfo"; // Redux action for user data
import { GetRecommendationEvaluationData } from "../../Services/RecommendationEvaluationManager/GetRecommendationEvaluationData"; // API service

// Main functional component for the Recommendations section
const RecommendationsSection = (props) => {
  // State to hold the recommendations and comments data
  const [Recommendations, setRecommendations] = useState(null);
  const [comments, setComments] = useState(null);
  const [listt, setlistt] = useState(); // Holds the fetched recommendations list

  // Redux dispatch and state selector
  const dispatch = useDispatch();
  const state = useSelector((state) => ({
    RecommendationEvaluationManager:
      state.RecommendationEvaluationManager.RecommendationEvaluationManager, // Recommendations evaluation data
    RecommendationEvaluationManagerUpdate:
      state.RecommendationEvaluationManager.UpdateRecommendationEvaluation, // Update status
    RecommendationEvaluationDropDown:
      state.RecommendationEvaluationManager.RecommendationEvaluationDropDown, // Dropdown options
    loadingRecommendationEvaluationManager:
      state.RecommendationEvaluationManager.loadingRecommendationEvaluationManager, // Loading state
  }));

  // Effect to fetch the dropdown options when the component mounts
  useEffect(() => {
    dispatch(
      GetRecommendationsDropDown({
        flowGUID: props.flowGUID, // Flow GUID for context
        ApplicationInfo: localStorage.getItem("aI_ApplicationInformationId_Manager"), // Application information from localStorage
      })
    );
  }, []);

  // Function to fetch the recommendation evaluation data
  const getRecommendationEvaluationDataManager = async () => {
    let data = await GetRecommendationEvaluationData(props.taskId); // Fetch data from API
    setlistt({ ...data.data.result }); // Update the local state with the fetched data
  };

  // Effect to fetch recommendations data when the component mounts
  useEffect(() => {
    getRecommendationEvaluationDataManager();
  }, []);

  // Effect to set user data when the component mounts
  useEffect(() => {
    dispatch(SetDataUser()); // Dispatch action to set user data in Redux store
  }, []);

  // Function to handle updating the recommendations list
  const updateList = (updatedRecommendation) => {
    // Dispatch update action with the modified recommendation data
    dispatch(
      UpdateRecommendationEvaluation({
        recommendationEvaluationGUID: updatedRecommendation?.recommendationEvaluationGUID,
        subTaskFlowGUID: updatedRecommendation?.subTaskFlowGUID,
        applicationGUID: updatedRecommendation?.applicationGUID,
        taskFlowGUID: updatedRecommendation?.taskFlowGUID,
        recommendationGUID: updatedRecommendation?.recommendationGUID,
        recommendationReason: updatedRecommendation?.recommendationReason,
      })
    );
  };

  // Render the recommendations section if the list is loaded
  return listt ? (
    <>
      <SharedDiv
        showTitle={true} // Show title of the section
        titleName="توصية" // Arabic word for "Recommendation"
        child={[
          <div className="form-gridScound">
            {/* Dropdown Component for selecting recommendation */}
            <AllDropDownsAHSF
              fieldsName={`${props.flowComponentTypeName}`}
              labelName={`${props.flowComponentName}`}
              show={true}
              disabled={props.disabled}
              arrayOoptionList={state.RecommendationEvaluationDropDown} // Options for dropdown
              KeyText={"recommendationName"} // Key for displaying text
              KeyValue={"recommendationGUID"} // Key for value
              dropdownType="normal"
              defaultValue={listt.recommendationGUID} // Default selected value
              onChange={(e) => {
                setlistt({ ...listt, recommendationGUID: e.target.value }); // Update local state
                updateList(listt); // Update the list
              }}
              onBlur={(e) => {
                updateList(listt); // Trigger update on blur
              }}
            />

            {/* Text Area Component for entering recommendation reason */}
            <TextAreaAHSF
              fieldsName="comments"
              show={true}
              disabled={props.disabled}
              defaultValue={listt.recommendationReason} // Default text area value
              onChange={(e) => {
                setlistt({ ...listt, recommendationReason: e.target.value }); // Update reason in local state
              }}
              onBlur={(e) => {
                updateList(listt); // Trigger update on blur
              }}
            />
          </div>,
        ]}
      />
    </>
  ) : (
    ""
  );
};

export default RecommendationsSection;
